import React from 'react'
import image_1 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo1.png'; 
import image_2 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo2.png'; 
import image_3 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo3.png'; 
import image_4 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo4.png'; 
import image_5 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo5.png'; 
import image_6 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo6.png'; 
import image_7 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo7.png'; 
import image_8 from '../../CustomAssets/Images/HomePage/carousel_brand_logos/brand_logo8.png'; 


export function Img1() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_1} alt="Image" />
  );
}
export function Img2() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_2} alt="Image" />
  );
}
export function Img3() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_3} alt="Image" />
  );
}
export function Img4() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_4} alt="Image" />
  );
}
export function Img5() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_5} alt="Image" />
  );
}
export function Img6() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_6} alt="Image" />
  );
}
export function Img7() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_7} alt="Image" />
  );
}
export function Img8() {
  return (
    <img decoding="async" className='bradLogos_carousal' src={image_8} alt="Image" />
  );
}
